/* pz-growth.js -- sticky ATC + Pavise routine builder. Vanilla, defer-loaded. */
(function () {
  'use strict';
  if (window.PZGrowth) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
  /* PUB_SUB_EVENTS is a top-level const in the theme's constants.js: not on window. */
  function pubSub() { return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null; }

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || '${{amount}}';
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  function getCartUI() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* Open the theme's cart UI from an /cart/add.js response that included `sections`. */
  function openCart(cartEl, res) {
    if (!cartEl || !res || !res.sections || typeof cartEl.renderContents !== 'function') return false;
    var items = res.items || [res];
    var last = items[items.length - 1] || {};
    try {
      cartEl.classList.remove('is-empty');
      cartEl.renderContents({ id: last.id, key: last.key, sections: res.sections });
      if (typeof window.publish === 'function' && pubSub()) {
        window.publish(pubSub().cartUpdate, { source: 'pz-growth', cartData: res });
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function addItems(items) {
    var cartEl = getCartUI();
    var body = { items: items };
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(document.activeElement);
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          var err = new Error(r.data.description || r.data.message || 'Could not add to cart.');
          throw err;
        }
        if (!openCart(cartEl, r.data)) window.location.href = cartUrl;
        return r.data;
      });
  }

  /* ---------------- Sticky add-to-cart ---------------- */
  function initSticky(bar) {
    var mq = window.matchMedia('(max-width: 989px)');
    var btn = bar.querySelector('[data-pz-sa-btn]');
    var label = bar.querySelector('[data-pz-sa-label]');
    var nowEl = bar.querySelector('[data-pz-sa-now]');
    var wasEl = bar.querySelector('[data-pz-sa-was]');
    var img = bar.querySelector('[data-pz-sa-img]');
    var variants = [];
    try { variants = JSON.parse(bar.querySelector('[data-pz-sa-variants]').textContent); } catch (e) {}
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    var pastForm = false;
    var blocked = false;
    var observer = null;
    var observed = null;

    function mainInfo() { return document.querySelector('product-info[id^="MainProduct-"]'); }
    function mainProductForm() {
      var info = mainInfo();
      return (info && info.querySelector('product-form')) || document.querySelector('product-form');
    }
    function mainSubmit() {
      var pf = mainProductForm();
      return pf && pf.querySelector('[type="submit"][name="add"], [type="submit"]');
    }
    function mainIdInput() {
      var pf = mainProductForm();
      return pf && pf.querySelector('form input[name="id"]');
    }

    function render() {
      var show = mq.matches && pastForm && !blocked;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('pz-sticky-atc-open', show);
      if (show) document.body.style.setProperty('--pz-sticky-atc-h', bar.offsetHeight + 'px');
    }

    function observe() {
      var target = mainSubmit() || mainProductForm();
      if (!target || target === observed || !('IntersectionObserver' in window)) return;
      if (observer) observer.disconnect();
      observed = target;
      observer = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        pastForm = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        render();
      });
      observer.observe(target);
    }

    function setAvailability(available) {
      btn.disabled = !available;
      label.textContent = available ? 'Add to cart' : 'Sold out';
    }

    function sync(variantId, variantObj) {
      var id = String(variantId || '');
      if (id) bar.setAttribute('data-variant-id', id);
      var v = byId[id];
      var showCompare = bar.getAttribute('data-show-compare') === 'true';
      var fmt = bar.getAttribute('data-money-format');
      if (v) {
        nowEl.textContent = v.price;
        if (wasEl) {
          wasEl.textContent = v.compare || '';
          wasEl.hidden = !v.compare;
        }
        if (img && v.image) img.src = v.image;
        setAvailability(v.available);
      } else if (variantObj) {
        nowEl.textContent = formatMoney(variantObj.price, fmt);
        var cmp = showCompare && variantObj.compare_at_price > variantObj.price;
        if (wasEl) {
          wasEl.textContent = cmp ? formatMoney(variantObj.compare_at_price, fmt) : '';
          wasEl.hidden = !cmp;
        }
        setAvailability(!!variantObj.available);
      } else if (!id) {
        setAvailability(false);
        btn.disabled = true;
        label.textContent = 'Unavailable';
      }
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var submit = mainSubmit();
      if (submit) {
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        submit.click();
        return;
      }
      /* Fallback: no theme form found. */
      var id = bar.getAttribute('data-variant-id');
      if (!id) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function () { window.location.href = cartUrl; })
        .catch(function () { window.location.href = cartUrl; });
    });

    /* Variant changes: theme pub/sub + the hidden id input's change event. */
    if (typeof window.subscribe === 'function' && pubSub()) {
      window.subscribe(pubSub().variantChange, function (evt) {
        var v = evt && evt.data && evt.data.variant;
        sync(v ? v.id : '', v);
        observed = null;
        observe();
      });
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id' && t === mainIdInput()) sync(t.value);
    });

    /* Never overlap the theme's cart drawer / notification / modals. */
    function checkBlocked() {
      var drawer = document.querySelector('cart-drawer');
      var note = document.getElementById('cart-notification');
      blocked = !!((drawer && drawer.classList.contains('active')) ||
        (note && note.classList.contains('active')) ||
        document.body.classList.contains('overflow-hidden'));
      render();
    }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(checkBlocked);
      [document.body, document.querySelector('cart-drawer'), document.getElementById('cart-notification')]
        .forEach(function (el) { if (el) mo.observe(el, { attributes: true, attributeFilter: ['class'] }); });
    }

    if (mq.addEventListener) mq.addEventListener('change', render);
    var idInput = mainIdInput();
    if (idInput && idInput.value) sync(idInput.value);
    observe();
    checkBlocked();
  }

  /* ---------------- Pavise routine builder ---------------- */
  function initRoutine(el) {
    var fmt = el.getAttribute('data-money-format');
    var boxes = Array.prototype.slice.call(el.querySelectorAll('.pz-routine__check'));
    var totalEl = el.querySelector('[data-pz-total]');
    var countEl = el.querySelector('[data-pz-count]');
    var kits = Array.prototype.slice.call(el.querySelectorAll('[data-pz-kit]'));
    var addBtn = el.querySelector('[data-pz-routine-add]');
    var addLabel = el.querySelector('[data-pz-routine-label]');
    var errEl = el.querySelector('[data-pz-routine-error]');
    var busy = false;

    function selected() { return boxes.filter(function (b) { return b.checked && !b.disabled; }); }

    function update() {
      var sel = selected();
      var total = sel.reduce(function (s, b) { return s + (parseInt(b.getAttribute('data-price'), 10) || 0); }, 0);
      totalEl.textContent = formatMoney(total, fmt);
      countEl.textContent = sel.length ? 'Total (' + sel.length + (sel.length === 1 ? ' item)' : ' items)') : 'Total';
      var steps = sel.map(function (b) { return b.getAttribute('data-step'); }).sort().join(',');
      kits.forEach(function (k) { k.hidden = k.getAttribute('data-pz-kit') !== steps; });
      addBtn.disabled = busy || sel.length === 0;
      addLabel.textContent = sel.length > 1 ? 'Add routine to cart' : (sel.length === 1 ? 'Add to cart' : 'Add routine to cart');
    }

    boxes.forEach(function (b) { b.addEventListener('change', update); });

    addBtn.addEventListener('click', function () {
      var sel = selected();
      if (!sel.length || busy) return;
      busy = true;
      errEl.hidden = true;
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.disabled = true;
      addLabel.textContent = 'Adding…';
      addItems(sel.map(function (b) { return { id: Number(b.value), quantity: 1 }; }))
        .catch(function (err) {
          errEl.textContent = (err && err.message) || 'Something went wrong. Please try again.';
          errEl.hidden = false;
        })
        .then(function () {
          busy = false;
          addBtn.classList.remove('is-loading');
          addBtn.removeAttribute('aria-busy');
          update();
        });
    });

    update();
  }

  function init() {
    var bar = document.querySelector('[data-pz-sticky-atc]');
    if (bar) initSticky(bar);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pz-routine]'), initRoutine);
  }

  window.PZGrowth = { formatMoney: formatMoney, addItems: addItems };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
